exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3PiJ2WyNY99H0v{background:#ebecf0}._2OVvGSq-7RG6DJ{padding:0 12px 12px}", ""]);

// exports
exports.locals = {
	"popover": "_3PiJ2WyNY99H0v",
	"popoverContent": "_2OVvGSq-7RG6DJ"
};